import DeliveryZoneModal from './DeliveryZoneModal.view';

export default DeliveryZoneModal;
